import { Pipe, PipeTransform } from '@angular/core';
import { Lookup } from '@common/constants';
import { Utilities } from '@common/utils';

export interface IntakeLabel {
  label: string; //original label
  transformedLabel?: string; //if we want to do custom label transform
  spousePartnerLabel?: string;
  replacementLabel?: string;
}

@Pipe({
  standalone: false,
  name: 'labelText',
})
export class LabelTextPipe implements PipeTransform {
  transform(value: IntakeLabel, replacementText?: string): string {
    //if there's already a value transformedLabel, return this (nothing needs to be done)
    if (value?.transformedLabel) {
      return value.transformedLabel;
    }

    const spouseLabelPlaceholder = '<<spouseLabel>>';
    if (replacementText && value.spousePartnerLabel && value.spousePartnerLabel.indexOf(spouseLabelPlaceholder) > -1) {
      return value.spousePartnerLabel.replace(spouseLabelPlaceholder, replacementText.toLowerCase());
    }
    const replacementLabel = '<<replacementLabel>>';
    if (replacementText && value.replacementLabel && value.replacementLabel.indexOf(replacementLabel) > -1) {
      //need to do a replaceAll
      const target = value.replacementLabel;
      const displayLabel = target.split(replacementLabel).join(replacementText);
      return displayLabel;
    }

    return value?.label;
  }

  //----Summary:----
  //creating a new function so it doesn't affect any code using the existing one above. This one is more generic/dynamic
  //gives us the ability to do more than the above function.
  //----Parameters:----
  //value: value IntakeLabel to be used
  //labelReplacements: collection of replacements. example { '<<findText>>': 'replaceText', '<<findText2>>': 'replacementText2' }
  //replacementProperty: the property (field) in the IntakeLabel object to use for content transform.
  transformLabel(
    value: IntakeLabel,
    labelReplacements: Record<string, string> = null,
    replacementProperty = 'replacementLabel',
    labelProperty = 'label' //default use label property, but can be changed by passing a different property
  ): string {
    const target = value[replacementProperty];
    if (target && labelReplacements && Object.keys(labelReplacements).length > 0) {
      let displayLabel = target;
      for (const [findText, replacementText] of Object.entries(labelReplacements)) {
        // ensure both find and replace have values
        if (findText && replacementText) {
          displayLabel = Utilities.replaceAll(displayLabel, findText, replacementText);
        }
      }
      return displayLabel;
    }
    return value[labelProperty];
  }

  transformAnswer(
    lookupItem: Lookup,
    labelReplacements: Record<string, string> = null,
    replacementProperty = 'thirdPartyValue'
  ): string {
    const value = lookupItem.displayValue;
    const target = lookupItem[replacementProperty];
    if (target && labelReplacements && Object.keys(labelReplacements).length > 0) {
      let displayValue = target;
      for (const [findText, replacementText] of Object.entries(labelReplacements)) {
        // ensure both find and replace have values
        if (findText && replacementText) {
          displayValue = Utilities.replaceAll(displayValue, findText, replacementText);
        }
      }
      return displayValue;
    }
    return value;
  }
}
